import React from "react"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Logo from "../../static/logo.svg"

export default class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
    }
  }

  toggleMenu() {
    let isOpen = this.state.isOpen
    this.setState({
      isOpen: !isOpen,
    })
  }

  render() {
    const isOpen = this.state.isOpen

    return (
      <header className={"header" + (isOpen ? " open" : "")}>
        <div className="header-inner">
          <div className="menu-toggle">
            <button onClick={() => this.toggleMenu()}>
              <FontAwesomeIcon icon={isOpen ? "times" : "bars"} />
            </button>
          </div>
          <div className="logo">
            <Link to="/">
              <Logo />
            </Link>
          </div>
          <nav className="menu">
            <Link to="/blogs/">Blog</Link>
            <Link to="/open-days/">Open Days</Link>
            <Link to="/galleries/">Galleries</Link>
            <Link to="/garden-plan/">Garden Plan</Link>
            <Link to="/contact-us/">Contact Us</Link>
          </nav>
        </div>
      </header>
    )
  }
}
